import TypeLoadForm from './TypeLoadForm'

export default TypeLoadForm
